import { IconNames } from '@dixa/lib-shared-habla';

type StatusIndicator = {
  icon: IconNames;
  color: string;
};

/**
 * Returns the appropriate icon and color for language evaluation kinds. Used in
 * language evaluation lists to show match status.
 */
export const getStatusIndicator = (kind: string): StatusIndicator => {
  switch (kind) {
    // Success - language matched
    case 'MatchOnRatingLanguage':
    case 'MatchOnDefaultLanguage':
      return {
        icon: 'check-circle-filled',
        color: 'var(--dixa-color-green-400)',
      };

    // Failure - language didn't match or is disabled
    case 'NoMatch':
    case 'Disabled':
      return {
        icon: 'close-circle-filled',
        color: 'var(--dixa-color-red-400)',
      };

    // Unknown language kind
    default:
      return {
        icon: 'info',
        color: 'var(--dixa-color-neutral-400)',
      };
  }
};
